import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Styles from './DateRangePeriod.module.scss';
import { themr } from 'analytics-ui/theme/themr';
import DateRangePickerWithTheme from 'analytics-ui/DateRangePicker/DateRangePicker';


class DateRangePeriod extends Component {
  static propTypes = {
    /** The timezone the date range is displayed in */
    timezone: PropTypes.string.isRequired,
    /** An array of the time ranges */
    timeRanges: PropTypes.array,
    /** Handler for changing the time range */
    onChange: PropTypes.func,
    /** Whether or not the date range period is static */
    isStatic: PropTypes.bool,
    theme: PropTypes.object,
  };

  handleDateUpdate = (index, dateData) => {
    const dates = this.props.timeRanges;
    dates[index] = dateData;
    this.props.onChange([...dates]);
  };

  render() {
    const {
      theme,
      isStatic,
      timezone,
      timeRanges,
    } = this.props;

    return (
      <div className={theme.date}>
        <DateRangePickerWithTheme
          timezone={timezone}
          dateRange={timeRanges[0]}
          className="date-range-popover"
          onChange={this.handleDateUpdate.bind(this, 0)}
          theme={{
            dateRangePicker: 'date-range',
          }}
          disabled={isStatic}
          isPeriod
        />
        <span className={theme.over}>over</span>
        <DateRangePickerWithTheme
          timezone={timezone}
          dateRange={timeRanges[1]}
          className="date-range-popover"
          onChange={this.handleDateUpdate.bind(this, 1)}
          theme={{
            dateRangePicker: 'date-range',
          }}
          disabled={isStatic}
          isPeriod
        />
      </div>
    );
  }
}

export default themr(DateRangePeriod, Styles);
